import { LOAD_STATES } from '../common';
import { AddDefinitionForm } from '../../core/definitions/definition-form-definition';
import { defaultFilterableOptions } from '../../core/default-filterable-options';
import { defaultDictionary } from '../../tests/fixtures/stubs/dictionary';
import { AmplifyCore } from '@codametrix/ui-common';
import { formErrors } from '../../stubs/form-errors';
const { paginationUtils } = AmplifyCore;
const dictionaryListPath = {
    displayName: 'Dictionaries',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/'
};
const dictionaryValueListPath = {
    displayName: 'Dictionary',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/',
    getDisplayName: (state, value)=>{
        const { dictionaryValues } = state;
        return dictionaryValues.selectedDictionary.name;
    }
};
const dictionaryValueDetailPath = {
    displayName: 'Edit',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/row/:rowId/(edit)'
};
const dictionaryUploadlCreatePath = {
    displayName: 'Create Dictionary',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/upload/new'
};
const dictionaryUploadlPath = {
    displayName: 'Upload Dictionary',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/upload'
};
const dictionaryInProgressPath = {
    displayName: 'Upload Dictionary',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/request/:requestId/'
};
const dictionaryMetadataKeyColumnPath = {
    displayName: 'Edit Metadata - Key Column',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/metadata/keyColumn'
};
const dictionaryHistoryPath = {
    displayName: 'Dictionary History',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/history'
};
const dictionaryCrossmapSelectPath = {
    displayName: 'Edit Metadata - Cross Maps',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/metadata/crossMaps/'
};
const dictionaryCrossmapEditPath = {
    displayName: 'Edit Cross Maps',
    path: '/cmx/admin/orgs/:orgId(\\d+)/dictionaries/dictionary/:dictionaryName/metadata/crossMaps/:columnName/(edit)',
    getDisplayName: (state, value)=>{
        const { dictionaryValues } = state;
        return dictionaryValues.columnMetadataEditor.activeColumn.name;
    }
};
export const dictionaryPaths = [
    dictionaryListPath,
    dictionaryValueListPath,
    dictionaryInProgressPath,
    dictionaryValueDetailPath,
    dictionaryUploadlCreatePath,
    dictionaryUploadlPath,
    dictionaryMetadataKeyColumnPath,
    dictionaryCrossmapSelectPath,
    dictionaryCrossmapEditPath,
    dictionaryHistoryPath
];
export const nameSortableOption = {
    sortField: 'name',
    sortDirection: 'ASC'
};
const sortablePageable = {
    pageableDefinition: {
        ...paginationUtils.emptyPageable
    },
    sortableOptions: [
        nameSortableOption
    ],
    filterableOptions: defaultFilterableOptions
};
const columnDefs = [
    {
        key: 'name',
        displayName: 'Dictionary Name'
    },
    {
        key: 'status',
        displayName: 'Status',
        transform: (dict)=>{
            if (dict.editStatus === 'UPDATE') {
                return 'Published with Draft';
            }
            return dict.status.charAt(0).toUpperCase() + dict.status.slice(1).toLowerCase();
        }
    },
    {
        key: 'updatedByFullName',
        displayName: 'Updated By'
    },
    {
        key: 'updatedDate',
        displayName: 'Date Updated'
    }
];
const filterLoadStates = new Map();
export const dictionary = {
    formErrors: formErrors.noErrors,
    label: 'Dictionary',
    formDef: AddDefinitionForm,
    itemName: 'Dictionaries',
    loadState: LOAD_STATES.initial,
    pageable: paginationUtils.emptyPageable,
    sortablePageable,
    items: [],
    activeItem: defaultDictionary,
    columnDefs,
    filterLoadStates,
    selectedOrg: {
        id: -1
    },
    associatedDictionaries: []
};
